export const getUserCasesCount = userId => `
SELECT
    count(Id)
FROM
    Case
WHERE
    OwnerId = '${userId}'
    AND Status NOT IN ('Resolvido', 'Fechado', 'Closed as Duplicate', 'Closed', 'Merged')
`;
